module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "margin": "5px 3px 0px 0px"
    },
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.increment(-1)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "margin": "5px 6px 0px 0px"
    },
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.increment(1)
      }
    }
  }, [_vm._v("+")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a87883"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/controls/NumberControl.vue
// module id = 2557
// module chunks = 1